import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  makeStyles,
  IconButton,
} from "@material-ui/core";
import { Edit } from "@material-ui/icons";
import EntityFormControl from "./EntityFormControl";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  headerCell: { fontWeight: "bold" },
  cell: { padding: "2px 16px 2px 8px" },
}));

const EntityTable = (props) => {
  const {
    tableColumns,
    disabledColumns,
    editColumns,
    entityDefinition,
    rows,
    formTitle,
    onEdit,
    filterExpression,
    ...rest
  } = props;
  const classes = useStyles();
  const [filteredRows, setFilteredRows] = useState(rows);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    const filterTokens = filterExpression
      .toLowerCase()
      .replace(/&/gi, "&,")
      .split(",");
    setFilteredRows(
      rows.filter((row) => {
        const arrayDisplayRow = tableColumns.map((col) =>
          entityDefinition[col].displayValue(row)
        );
        const arrayDisplayString =
          arrayDisplayRow.join("&").toLowerCase() + "&";
        const matchesAllTokens = !filterTokens.some(
          (tok) => !arrayDisplayString.includes(tok)
        );
        return matchesAllTokens;
      })
    );
    setPage(0);
  }, [filterExpression, rows, tableColumns, entityDefinition]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      <Table size="small" {...rest}>
        <TableHead>
          <TableRow>
            {tableColumns.map((col) => {
              // console.log(col);
              // console.log(entityDefinition[col]);
              return (
                <TableCell
                  key={col}
                  className={clsx(classes.headerCell, classes.cell)}
                >
                  {entityDefinition[col].displayName.replace(/ /g, "\u00a0")}
                </TableCell>
              );
            })}
            <TableCell
              className={clsx(classes.headerCell, classes.cell)}
              align="center"
            >
              Edit
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {filteredRows
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((rowData) => (
              <TableRow key={JSON.stringify(rowData)}>
                {tableColumns.map((col) => (
                  <TableCell className={clsx(classes.cell)} key={col}>
                    {(
                      entityDefinition[col].displayValue(rowData) || ""
                    ).replace(/-/g, "\u2011")}
                  </TableCell>
                ))}
                <TableCell className={clsx(classes.cell)} align="center">
                  <EntityFormControl
                    buttonComponent={(buttonProps) => (
                      <IconButton {...buttonProps}>
                        <Edit />
                      </IconButton>
                    )}
                    title={formTitle}
                    columns={editColumns || tableColumns}
                    entityDefinition={entityDefinition}
                    initialData={rowData}
                    onSubmit={onEdit}
                    disabledColumns={disabledColumns}
                  />
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={filteredRows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </>
  );
};

export default EntityTable;

EntityTable.defaultProps = {
  filterExpression: "",
};

EntityTable.propTypes = {
  tableColumns: PropTypes.arrayOf(PropTypes.string).isRequired,
  editColumns: PropTypes.arrayOf(PropTypes.string),
  disabledColumns: PropTypes.arrayOf(PropTypes.string),
  entityDefinition: PropTypes.object.isRequired,
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  formTitle: PropTypes.string.isRequired,
  onEdit: PropTypes.func.isRequired,
  filterExpression: PropTypes.string,
};
